import VcNumInput from './src/vc-num-input'

VcNumInput.install = function (Vue) {
  Vue.component(VcNumInput.name, VcNumInput)
}

export default VcNumInput
